module.exports = __webpack_public_path__ + "static/OldMansJourney5-59f0af9110ccfe9a0cde63f62ae50f0a.png";